import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import moment from "moment";

const getAdjustmentIndexFilters = () => {
    //return axios.get(`/api/Adjustment/index/list`, { headers: authHeaderJson() } );
    return {
        data: {
            succeeded: true,
            data: [{id: 1, code: "CODEIDX1", name: "IDX NAME 1"}, {id: 2, code: "CODEIDX2", name: "IDX NAME 2"}, {id: 3, code: "CODEIDX3", name: "IDX NAME 3"}]
        }
    }
};

export {
    getAdjustmentIndexFilters
}